import React, { Component } from 'react'

import PropTypes from 'prop-types'
import {updateMenu} from '../../container/actions/menu-action'
import {connect} from 'react-redux'
import { bindActionCreators } from 'redux';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import {
  NavLink,
} from "react-router-dom";


class MenuItemCustom extends Component {

    constructor(props){
        super(props);
        this.handleMenuClick = this.handleMenuClick.bind(this);
    }

    handleMenuClick = event => {
       event.preventDefault();
       this.props.handleMenuClick(this.props.url);
       this.props.closePanel();
    }

    render() {
        return (
            <ListItem button className="menuChoix" onClick={this.handleMenuClick}>
                <NavLink to={this.props.url} className="menuChoixLink">
                <ListItemIcon>
                    {this.props.icon}
                </ListItemIcon>
                <ListItemText primary={this.props.libelle} /></NavLink>
            </ListItem>
        )
    }
}

const mapStateToProps = props => ({
    menu: props.url
});

const mapActionsToProps = (dispatch) =>{
    return bindActionCreators({
        handleMenuClick: updateMenu
    }, dispatch)
};

MenuItemCustom.propTypes = {
    libelle: PropTypes.string.isRequired,
    icon: PropTypes.object.isRequired,
    closePanel: PropTypes.func.isRequired,
    url: PropTypes.string.isRequired,
}

export default connect(mapStateToProps, mapActionsToProps)(MenuItemCustom)


// WEBPACK FOOTER //
// ./src/components/header/MenuItemCustom.js